import React from 'react';
import Logo from './Logo';

const Header = () => (
  <div className="header">
    <Logo />
  </div>
);

export default Header;
